import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import * as yup from 'yup';

/** Common validation schema for any id-like numbers: any value which must positive integer */
export const idLikeSchema = yup
  .number()
  .positive(DtoMessageEnum.NOT_POSITIVE)
  .integer(DtoMessageEnum.NOT_INTEGER);
